export const edutech_heading = [
    {
        title: "Solution for Learning &"      
    },
    {
        title: "Training (EduTech)"
    },
  ]; 